


























import { Component } from 'vue-property-decorator';

import NotificationMenuDropdown from './NotificationMenuDropdown.vue';
import NotificationService from '@/api/NotificationService';
import {
  ENotificationGroups,
  ENotificationStatus,
  INotification
} from '@/models/notification';
import DateUtils from '@/utils/DateUtils';
import { treatError } from '@/utils';
import TopBarMenu from '@/componentsV2/atoms/TopBarMenu/TopBarMenu.vue';
import PaginationUtils, { IPagination } from '@/utils/PaginationUtils';

@Component({
  components: {
    NotificationMenuDropdown
  }
})
export default class NotificationMenu extends TopBarMenu {
  notificationsInGroups: any = {};
  allNotifications: INotification[] = [];
  unreadNotifications: number = 0;
  service: NotificationService = new NotificationService();
  pagination: IPagination = PaginationUtils.defaultPagination();
  loading = false;
  limit = 15;
  groups = {
    today: (item: INotification) => {
      return this.differenceDays(item.createdAt) <= 1;
    },
    yesterday: (item: INotification) => {
      return this.differenceDays(item.createdAt) <= 2;
    },
    '7-days': (item: INotification) => {
      return this.differenceDays(item.createdAt) <= 7;
    },
    older: (item: INotification) => {
      return this.differenceDays(item.createdAt) > 7;
    }
  };

  get haveNotifications() {
    return this.allNotifications.length > 0;
  }

  get isNotification() {
    return (
      this.allNotifications.filter(item => item.status !== 'seen').length > 0
    );
  }

  get tPrefix() {
    return 'menus.topbar.notificationMenuDrop';
  }

  differenceDays(date: string) {
    return DateUtils.getDifferenceDays(date, new Date().toString());
  }

  handleShowMenu() {
    this.showMenu();
    this.reloadList({
      clearList: true,
      query: { seen: true }
    });
  }

  handleClick() {
    this.handleShowMenu();
  }

  async clickSeenNotification() {
    try {
      await this.service.seenNotifications();
      await this.reloadList({
        clearList: true
      });
      this.$notification(
        String(this.$t(`${this.tPrefix}.markSeenSuccess`)),
        'success'
      );
    } catch (e) {
      treatError(e);
    }
  }

  async reloadList({ clearList = false, query = {} } = {}) {
    if (clearList) {
      this.allNotifications = [];
      this.notificationsInGroups = {};
      this.pagination = PaginationUtils.defaultPagination();
    }

    if (!this.pagination.mustCallApi) return;

    let endpointPath = '';

    if (this.pagination.next) {
      endpointPath = this.pagination.next;
    }

    this.loading = !!clearList;

    const { data } = await this.service.getNotifications({
      params: { ...query, limit: !endpointPath && this.limit },
      endpointPath
    });

    const { items, links } = data;

    let allDataNotification = data.items;

    Object.assign(this.pagination, {
      next: links.next,
      mustCallApi: !!links.next
    });

    if (!clearList) allDataNotification = [...this.allNotifications, ...items];

    const notifications: any = {
      today: [],
      yesterday: [],
      '7-days': [],
      older: []
    };

    allDataNotification.forEach((element: any) => {
      for (const group of Object.keys(this.groups)) {
        if (this.groups[group as ENotificationGroups](element)) {
          notifications[group].push(element);
          break;
        }
      }
    });

    this.allNotifications = allDataNotification;

    this.notificationsInGroups = notifications;

    this.loading = false;
  }

  async created() {
    this.reloadList({
      clearList: true,
      query: { status: ENotificationStatus.NEW }
    });
  }
}
